import { render, staticRenderFns } from "./AccountBanksHead.vue?vue&type=template&id=026d8816&scoped=true"
import script from "./AccountBanksHead.vue?vue&type=script&lang=js"
export * from "./AccountBanksHead.vue?vue&type=script&lang=js"
import style0 from "./AccountBanksHead.vue?vue&type=style&index=0&id=026d8816&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026d8816",
  null
  
)

export default component.exports